import { NavigationRoute } from 'views/Dashboard/routes';
import EditEngineerView from 'views/Engineers/EditEngineer';
import Engineer from 'views/Engineers/Engineer';
import { engineerDomain } from 'models';
import EngineerAppointments from 'views/Engineers/EngineerAppointments';

const engineersRoutes = (): NavigationRoute[] => [
  {
    to: `/dashboard/${engineerDomain.urlPath}/:id/edit`,
    component: EditEngineerView
  },
  {
    to: `/dashboard/${engineerDomain.urlPath}/:id`,
    component: Engineer
  },
  {
    to: `/dashboard/${engineerDomain.urlPath}/:id/appointments`,
    component: EngineerAppointments
  }
];

export default engineersRoutes;
